module.exports = __webpack_public_path__ + "static/media/BHSheep.svg";